import { Education } from 'types/Education';

export const filterEmptyEducation = (educations: Education[]): Education[] =>
  educations.filter(({ schoolName }) => !!schoolName);
